import { Lock } from 'lucide-react';
import { JourneySwitch } from './JourneySwitch';
import type { Occasion } from './journeyModel';

/** Was unter einem Anlass steht: Pflicht, Schalter oder — ohne Schreibrecht — nur der Stand. */
export function OccasionControl(props: {
  label: string;
  occasion: Occasion;
  enabled: boolean;
  editable: boolean;
  busy: boolean;
  pending: boolean;
  onChange: (enabled: boolean) => void;
}) {
  if (props.occasion.required) {
    return (
      <span className="text-ink-soft inline-flex min-h-11 items-center gap-1.5 text-xs">
        <Lock size={13} aria-hidden />
        Immer aktiv
      </span>
    );
  }
  if (!props.editable) {
    return (
      <span className="text-ink-soft inline-flex min-h-11 items-center text-xs">
        {props.enabled ? 'Aktiv' : 'Inaktiv · wird nicht versendet'}
      </span>
    );
  }
  return (
    <JourneySwitch
      label={props.label}
      checked={props.enabled}
      pending={props.pending}
      disabled={props.busy}
      onChange={props.onChange}
    />
  );
}
